/**
 * Created by caleb on 17/06/.
 */

//

export function jqueryConfirm(others, opts){
  const selfTitle = others.title || '';
  const selfPlaceholder = others.placeholder || '';
  const submitText = others.submitText || '提交'
  const cancelText = others.cancelText || '取消'
  const submitFun = others.submitFun || function(){}
  const cancelFun = others.cancelFun || function(){}
  const content = others.content || ''

  var opts = $.extend({
    closeIcon: true,
    boxWidth: "25%",
    useBootstrap: false,
    title: '',
    content: content ? content : '<form action="" class="formName">' +
    '<div class="form-group">' +
    '<label style="margin-bottom:15px;">'+ selfTitle +'</label>' +
    '<input type="text" placeholder='+ selfPlaceholder +' class="name form-control" required />' +
    '</div>' +
    '</form>',
    buttons: {
        formSubmit: {
            text: submitText,
            btnClass: 'btn-blue',
            action: submitFun
        },
        cancel: {
            text: cancelText,
            action: cancelFun
        },
    },
    onContentReady: function () {
        // bind to events
        var jc = this;
        this.$content.find('form').on('submit', function (e) {
            // if the user submits the form by pressing enter in the field.
            e.preventDefault();
            jc.$$formSubmit.trigger('click'); // reference the button and click it
        });
    }
  }, opts);
  $.confirm(opts);
}

export function jqueryAlert(others,opts){
  const selfTitle = others.title || '';
  const selfContent = others.content || '';
  const submitText = others.submitText || '确定'
  const submitFun = others.submitFun || function(){}
  var opts = $.extend({
    closeIcon: true,
    title:selfTitle,
    content: selfContent,
    buttons:{
      formSubmit: {
          text: submitText,
          btnClass: 'btn-blue',
          action: submitFun
      },
    }
  }, opts);
  $.alert(opts);
}

export function addExtraParam(url, p) {
     var index = url.indexOf('?'),
         setSearchStr = function(str, p) {
             var refes = str.split("&"),
                 item = null,
             sp = {};

             for (var i = 0; i < refes.length; i++) {
                 item = refes[i];
                 var iArr = item.split("=");
                 if (iArr[0]) {
                     sp[iArr[0]] = iArr[1];
                 }
             };
             return $.param($.extend(sp, p));
         };

     if (index === -1) {
         //var arr = url.split('#');
         //return arr[0] + '?' + $.param(p) + ((arr[1] && arr[1].length > 0) ? '#' + arr[1] : '');
         return url + '?' + $.param(p);
     } else {
         var arr = url.split('?'),
             tem = arr[1];

         if (tem && tem !== '') {
             var arr3 = tem.split('#'),
                 search = '';
             if (arr3.length > 1) {
                 return arr[0] + '?' + setSearchStr(arr3[0], p) + '#' + arr3[1];
             } else {
                 return arr[0] + '?' + setSearchStr(arr3[0], p);
             }
         }
         return arr[0];
     }
     return url;

 }

  export function isUrl(){
    const url = arguments[0]
    const reg = ['/^(https?|ftp|file):\/\/[-A-Za-z0-9+&@#\/%?=~_|!:,.;]+[-A-Za-z0-9+&@#\/%=~_|]/']
    var isUrl = true
    for(let i=0,len=reg.length; i<len; i++){
      const strRegex = reg[i]
      const re = new RegExp(strRegex)
      isUrl = re.test(url)
      if(!isUrl){
        return false
      }
    }

    return isUrl
  }

 export function originAddParam(url,obj){
  let result = ''
  for(let i in obj){
    const value = obj[i]
    result = `${result}&${i}=${value}`
  }
  return url+'?'+result.substr(1)
 }

 export function parseTime(time, cFormat) {
   if (arguments.length === 0) {
     return null;
   }
   const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
   let date;
   if (typeof time == 'object') {
     date = time;
   } else {
     if (('' + time).length === 10) time = parseInt(time) * 1000;
     date = new Date(time);
   }
   const formatObj = {
     y: date.getFullYear(),
     m: date.getMonth() + 1,
     d: date.getDate(),
     h: date.getHours(),
     i: date.getMinutes(),
     s: date.getSeconds(),
     a: date.getDay()
   };
   const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
     let value = formatObj[key];
     if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
     if (result.length > 0 && value < 10) {
       value = '0' + value;
     }
     return value || 0;
   });
   return time_str;
 }

  export function deleteEmptyObj(obj) {
    for(let i in obj){
      if(!obj[i]){
        delete obj[i]
      }
    }
     return obj
  } 

 export function getDashTime(date) {
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      a: date.getDate()
    };
    return `${formatObj.y}-${formatObj.m}-${formatObj.a}`;
 }

 export function formatTime(time, option) {
   time = +time * 1000;
   const d = new Date(time);
   const now = Date.now();

   const diff = (now - d) / 1000;

   if (diff < 30) {
     return '刚刚'
   } else if (diff < 3600) { // less 1 hour
     return Math.ceil(diff / 60) + '分钟前'
   } else if (diff < 3600 * 24) {
     return Math.ceil(diff / 3600) + '小时前'
   } else if (diff < 3600 * 24 * 2) {
     return '1天前'
   }
   if (option) {
     return parseTime(time, option)
   } else {
     return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
   }
 }

// 格式化时间
 export function getQueryObject(url) {
   url = url == null ? window.location.href : url;
   const search = url.substring(url.lastIndexOf('?') + 1);
   const obj = {};
   const reg = /([^?&=]+)=([^?&=]*)/g;
   search.replace(reg, (rs, $1, $2) => {
     const name = decodeURIComponent($1);
     let val = decodeURIComponent($2);
     val = String(val);
     obj[name] = val;
     return rs;
   });
   return obj;
 }

  export function getFormatTime(time){
    let t = new Date(time)
    let y = t.getFullYear()
    let M = zfill(t.getMonth()+1, 2)
    let d = t.getDate()
    let h = t.getHours()
    let m = t.getMinutes()
    let s = t.getSeconds()
    return  `${y}/${M}/${d>=10? d : ('0'+d)} ${h>=10 ? h : ('0'+h)}:${m>=10 ? m : ('0'+m)}:${s>=10 ? s : ('0'+s)}`
  }

  export function createUniqueString() {
   const timestamp = +new Date() + '';
   const randomNum = parseInt((1 + Math.random()) * 65536) + '';
   return (+(randomNum + timestamp)).toString(32);
  }

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
 export function getByteLen(val) {
   let len = 0;
   for (let i = 0; i < val.length; i++) {
     if (val[i].match(/[^\x00-\xff]/ig) != null) {
       len += 1;
     } else { len += 0.5; }
   }
   return Math.floor(len);
 }

 export function cleanArray(actual) {
   const newArray = [];
   for (let i = 0; i < actual.length; i++) {
     if (actual[i]) {
       newArray.push(actual[i]);
     }
   }
   return newArray;
 }

 export function param(json) {
   if (!json) return '';
   return cleanArray(Object.keys(json).map(key => {
     if (json[key] === undefined) return '';
     return encodeURIComponent(key) + '=' +
            encodeURIComponent(json[key]);
   })).join('&');
 }

 export function param2Obj(url) {
   const search = url.split('?')[1];
   return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
 }

 export function html2Text(val) {
   const div = document.createElement('div');
   div.innerHTML = val;
   return div.textContent || div.innerText;
 }

 export function objectMerge(target, source) {
    /* Merges two  objects,
     giving the last one precedence */

   if (typeof target !== 'object') {
     target = {};
   }
   if (Array.isArray(source)) {
     return source.slice();
   }
   for (const property in source) {
     if (source.hasOwnProperty(property)) {
       const sourceProperty = source[property];
       if (typeof sourceProperty === 'object') {
         target[property] = objectMerge(target[property], sourceProperty);
         continue;
       }
       target[property] = sourceProperty;
     }
   }
   return target;
 }


 export function scrollTo(element, to, duration) {
   if (duration <= 0) return;
   const difference = to - element.scrollTop;
   const perTick = difference / duration * 10;
   setTimeout(() => {
     //console.log(new Date())
     element.scrollTop = element.scrollTop + perTick;
     if (element.scrollTop === to) return;
     scrollTo(element, to, duration - 10);
   }, 10);
 }

 export function toggleClass(element, className) {
   if (!element || !className) {
     return;
   }
   let classString = element.className;
   const nameIndex = classString.indexOf(className);
   if (nameIndex === -1) {
     classString += '' + className;
   } else {
     classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
   }
   element.className = classString;
 }

 export const pickerOptions = [
   {
     text: '今天',
     onClick(picker) {
       const end = new Date();
       const start = new Date(new Date().toDateString());
       end.setTime(start.getTime());
       picker.$emit('pick', [start, end]);
     }
   }, {
     text: '最近一周',
     onClick(picker) {
       const end = new Date(new Date().toDateString());
       const start = new Date();
       start.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
       picker.$emit('pick', [start, end]);
     }
   }, {
     text: '最近一个月',
     onClick(picker) {
       const end = new Date(new Date().toDateString());
       const start = new Date();
       start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
       picker.$emit('pick', [start, end]);
     }
   }, {
     text: '最近三个月',
     onClick(picker) {
       const end = new Date(new Date().toDateString());
       const start = new Date();
       start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
       picker.$emit('pick', [start, end]);
     }
   }]

 export function getTime(type) {
   if (type === 'start') {
     return new Date().getTime() - 3600 * 1000 * 24 * 90
   } else {
     return new Date(new Date().toDateString())
   }
 }


  /**
   * zfill 用0向前填充，并返回指定位数的数字
   * @param {Number} num 原数字
   * @param {Number} length 返回数字位数
   * return {Number} 如 zfill(123, 6) 返回 000123
   */
  export function zfill(num, length) {
    return (Array(length).join('0') + num).slice(-length)
  }






// WEBPACK FOOTER //
// ./src/utils/index.js